"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERCURYO_SCRIPTS = void 0;
/* eslint-disable no-undef */
const react_1 = __importStar(require("react"));
exports.MERCURYO_SCRIPTS = {
    // widget created in prod dashboard: https://partners.mercuryo.io/
    url: "https://widget.mercuryo.io/embed.2.0.js",
    buy: {
        widgetId: "85b39026-8a0d-4a0c-964f-e2993cf01738",
    },
    sell: {
        widgetId: "8dd4b9ce-5b08-4718-b9a0-bd2e6c33c001",
    },
};
const MercuryoWidget = (_a) => {
    var { crypto = "BCH", env = "production", fiat, amount, lang = "en" } = _a, rest = __rest(_a, ["crypto", "env", "fiat", "amount", "lang"]);
    const mercuryoRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const loadMercuryo = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (mercuryoRef === null || mercuryoRef.current === null)
                    return;
                const { hostname } = (window === null || window === void 0 ? void 0 : window.location) || "";
                const domain = hostname === "sell.bitcoin.com" ? "sell" : "buy";
                yield window.mercuryoWidget.run({
                    widgetId: exports.MERCURYO_SCRIPTS[domain].widgetId,
                    host: mercuryoRef.current,
                    type: "buy",
                    fiatAmount: amount,
                    currency: crypto || "BCH",
                    fixCurrency: true,
                    fiatCurrency: fiat,
                    lang,
                });
            }
            catch (err) {
                // eslint-disable-next-line no-console
                console.log("mercuryo load ", err);
            }
        });
        loadMercuryo();
    }, [amount, crypto, env, fiat, lang, mercuryoRef]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", Object.assign({ ref: mercuryoRef, id: "mercuryo-widget", style: { height: "500px" } }, rest))));
};
exports.default = MercuryoWidget;
//# sourceMappingURL=MercuryoWidget.js.map